var Handlebars = require("../lib/handlebars.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"image",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"breadcrumb",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + ">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "</div><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"img-container",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + " data-exclude=\"true\"><img src=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "\"></div><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"img-info",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + ">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"width") : depth0), depth0))
    + " × "
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"height") : depth0), depth0))
    + "</div></div>";
},"useData":true});